<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';

	import { Button, ButtonV2, Container, Text } from '@Shelly/shelly-design-system';

	import { CAMERA_CLOUD_STORAGE_GRADIENT } from 'src/helpers/camera_cloud_storage_helpers';
	import type { CameraCloudStoragePlanTier } from 'src/types/CameraCloudStorage';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let tier: CameraCloudStoragePlanTier;

	const dispatch = createEventDispatcher<{ click: void }>();
</script>

<Container padding="0">
	<div class="d-flex justify-content-center mb-m">
		<div class="ccs-success-emblem" style={`background: ${CAMERA_CLOUD_STORAGE_GRADIENT};`}>
			<i class="fas fa-camera" aria-hidden="true" />
		</div>
	</div>

	<Text class="text-center" element="h1">
		{$format('text_title_camera_cloud_storage_congrats', {
			default: 'Welcome to Camera Cloud Storage!',
		})}
	</Text>
	<Text class="text-center text-color-muted mt-m" styleType="body">
		{$format('text_desc_camera_cloud_storage_congrats', {
			default: `Your ${tier} Cameras Cloud Storage plan is now active. Pick which cameras should use your new slots in the next step.`,
			values: { count: tier },
		})}
	</Text>

	<div class="d-flex justify-content-center mt-m">
		{#if $showNewLayout}
			<ButtonV2 on:click={() => dispatch('click')}>
				{$format('button_assign_cameras', {
					default: 'Assign cameras',
				})}
			</ButtonV2>
		{:else}
			<Button on:click={() => dispatch('click')}>
				{$format('button_assign_cameras', {
					default: 'Assign cameras',
				})}
			</Button>
		{/if}
	</div>
</Container>

<style>
	.ccs-success-emblem {
		width: 96px;
		height: 96px;
		border-radius: 50%;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		color: #ffffff;
		font-size: 36px;
	}
</style>
